import { site } from '@yola/ws-sdk';
import trackAsync from '../track-async';
import getTemplateBuildSlugTrait from '../helpers/get-template-build-slug-trait';

const trackAsyncEvent = (event, traits = {}) =>
  trackAsync(event, {
    siteId: site.accessors.getSiteId(),
    templateBuildSlug: getTemplateBuildSlugTrait(),
    ...traits,
  });

export default trackAsyncEvent;
